import React, { useState,useEffect } from "react";
import Modal from "react-modal";
import { HTTP } from "./../api/http-common";
import Swal from "sweetalert2";
import { MultiSelect } from "react-multi-select-component";

function CouponModal({showModal,setShowModal,formData, setFormData,fetchCoupons,vendorAddresses}) {
    const [selectedAddresses, setSelectedAddresses] = useState([]);
    const [couponCodeError, setcouponCodeError] = useState("");
    const [couponTypeError, setcouponTypeError] = useState("");
    const [couponValueError, setcouponValueError] = useState("");
    const [minimumPurchaseError, setminimumPurchaseError] = useState("");
    const [maximumUsesError, setmaximumUsesError] = useState("");

    const [startDateError, setstartDateError] = useState("");
    const [expirationDateError, setexpirationDateError] = useState("");
    const [descriptionError, setdescriptionError] = useState("");
    const [statusError, setstatusError] = useState("");

    const formattedOptions = vendorAddresses.map(option => ({
      label: option.address,
      value: option.id,
    }));

    
    useEffect(() => {
      const selectedValues = formData.coupon_selected_addresses;
      const formattedSelectedValues = selectedValues.map(option => ({
        label: option.address,
        value: option.id,
      }));
      setSelectedAddresses(formattedSelectedValues);
    }, [formData.coupon_selected_addresses]);


    const resetValidationErrors = () => {
        setcouponCodeError('');
        setcouponTypeError('');
        setcouponValueError('');
        setminimumPurchaseError('');
        setmaximumUsesError('');

        setstartDateError('');
        setexpirationDateError('');
        setdescriptionError('');
    };
    const validateField = () => {
        resetValidationErrors();
    
        let checked = true;
          if (formData.coupon_code === '') {
            setcouponCodeError('Please enter code');
              if (checked) {
                  checked = false;
              }
          } else if ((formData.coupon_code).length < 5) {
            setcouponCodeError("Please enter minimum 5 characters");
              if (checked) {
                  checked = false;
              }
          } else if ((formData.coupon_code).length > 50) {
            setcouponCodeError("Max character limit is 50");
              if (checked) {
                  checked = false;
              }
          }

          if (formData.coupon_type === '') {
            setcouponTypeError('Select type');
              if (checked) {
                  checked = false;
              }
          }

          const regex = /^\d+(\.\d{1,2})?$/;
          if (formData.coupon_value === '') {
            setcouponValueError('Please enter code value');
              if (checked) {
                  checked = false;
              }
          }else if (!regex.test(formData.coupon_value)) {
            setcouponValueError("Please enter a valid coupon value (up to two decimal places)");
              if (checked) {
                  checked = false;
              }
          }

          if (formData.minimum_purchase === '') {
            setminimumPurchaseError('Please enter minimum purchase value');
              if (checked) {
                  checked = false;
              }
          }else if (!regex.test(formData.minimum_purchase)) {
            setcouponValueError("Please enter a valid minimum purchase value (up to two decimal places)");
              if (checked) {
                  checked = false;
              }
          }

          if (formData.maximum_uses === '') {
            setmaximumUsesError('Please enter code usage limit');
              if (checked) {
                  checked = false;
              }
          }

          if (formData.start_date === '') {
            setstartDateError('Please select start date');
              if (checked) {
                  checked = false;
              }
          }

          if (formData.expiration_date === '') {
            setexpirationDateError('Please select expiration date');
              if (checked) {
                  checked = false;
              }
          }

          if (formData.description === '') {
            setdescriptionError('Please enter description');
              if (checked) {
                  checked = false;
              }
          }
          

        return checked;
      };
      const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
      };
      
      useEffect(() => {
        setFormData({ ...formData, ['coupon_addresses']: selectedAddresses });
      }, [selectedAddresses]);

    const handleAddCoupon = async (event) => {
        event.preventDefault();
        if (validateField()) {
          // const formData = new FormData(event.target);
          try {
            const access_token = localStorage.getItem("access_token");
            let config = {
              headers: { "Content-Type": "application/json", token: access_token },
            };
        
            await HTTP.post("/coupon/add", formData, config)
              .then((response) => {
                if (response.status === 200) {
                //   console.log(response.data)
                  // alert("Coupon added successfully");
                  Swal.fire(response.data.message);
                  
                  // Close the modal after coupon is added
                  setShowModal(false);
    
                  fetchCoupons();
                  // navigate("/coupons"); // Navigate to the /coupon page
                }
              })
              .catch((error) => {
                Swal.fire("Error", "There was an error adding/updating the coupon.", "error");
                if (error.response && error.response.status === 406) {
                  Swal.fire({
                    title: 'Error!',
                    text: error.response.data.detail,
                    icon: 'error',
                    confirmButtonText: 'Ok'
                  })
                }
              });
          } catch (error) {
            Swal.fire("Error", "There was an unexpected error.", "error");
          }
        }
        
      };
      const styles = {
        modal: {
            content: {
            padding: '30px',
            borderRadius: '10px',
            backgroundColor: '#fff',
            maxWidth: '600px',
            margin: 'auto',
            boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
            position:'absolute'
            },
        },
        }
  return (
    <>
    {/* Start Model to add form  */}
    <Modal
        isOpen={showModal}
        onRequestClose={() => setShowModal(false)}
        contentLabel="Add Deals"
        style={styles.modal}
      >
        <div className="flex flex-col space-y-1.5 text-center sm:text-left">
        <h2 id="radix-:rg:" className="text-lg font-semibold leading-none tracking-tight">
          Deal
        </h2>
        <p id="radix-:rh:" className="text-sm text-muted-foreground">
          &nbsp;
        </p>
      </div>
        {/* Coupon form */}
        <form className="space-y-8ReactModal__Overlay ReactModal__Overlay--after-open custom-overlay-position" onSubmit={handleAddCoupon}>
        <div className="grid grid-cols-2 gap-4">
          {/* Coupon Code Input */}
          <div className="space-y-2">
            <label
              htmlFor=":r1r:-form-item"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Code
            </label>
            <div className="relative space-y-1">
              <input
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                placeholder="Enter coupon code"
                name="coupon_code"
                id=":r1r:-form-item"
                aria-describedby=":r1r:-form-item-description"
                aria-invalid="false"
                value={formData.coupon_code}
              onChange={handleChange}
              />
              {couponCodeError && <span className="text-sm text-red-500">{couponCodeError}</span>}
            </div>
          </div>
          {/* Coupon Type Dropdown */}
          <div className="space-y-2">
            <label
              htmlFor=":r1s:-form-item"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Type
            </label>
            <select
              aria-hidden="true"
              tabIndex="-1"
              name="coupon_type"
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
              value={formData.coupon_type} onChange={handleChange}
            >
              <option value="">Select</option>
              <option value="1">Fixed Amount</option>
              <option value="2">Percentage</option>
            </select>
            {couponTypeError && <span className="text-sm text-red-500">{couponTypeError}</span>}
          </div>
          
          {/* Coupon Type Dropdown */}
          <div className="space-y-2">
            <label
              htmlFor=":r1s:-form-item"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Location
            </label>
            {/* <pre>{JSON.stringify(selectedAddresses)}</pre> */}
              <MultiSelect
                options={formattedOptions}
                name="coupon_addresses"
                value={selectedAddresses}
                onChange={setSelectedAddresses}
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                labelledBy="Select"
              />
            {couponTypeError && <span className="text-sm text-red-500">{couponTypeError}</span>}
          </div>
          {/* Coupon Value Input */}
          <div className="space-y-2">
            <label
              htmlFor=":r1u:-form-item"
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
            >
              Value
            </label>
            <div className="relative space-y-1">
              <input
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                placeholder="Enter coupon value"
                name="coupon_value"
                id=":r1u:-form-item"
                aria-describedby=":r1u:-form-item-description"
                aria-invalid="false"
                value={formData.coupon_value}
                onChange={handleChange}
              />
              {couponValueError && <span className="text-sm text-red-500">{couponValueError}</span>}
            </div>
          </div>
          {/* Add other inputs like Start Date, Expiration Date similarly */}
          <div className="space-y-2">
            <label
             htmlFor="minimum_purchase" 
              className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
              >
                Minimum Purchase
            </label>
            <div className="relative space-y-1">
              <input
                id="minimum_purchase"
                name="minimum_purchase"
                placeholder="Minimum Purchase"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                value={formData.minimum_purchase}
                onChange={handleChange}
              />
              {minimumPurchaseError && <span className="text-sm text-red-500">{minimumPurchaseError}</span>}
            </div>
          </div>
          <div className="space-y-2">
            <label
             htmlFor="maximum_uses"
             className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
             >
              Usage Limit
            </label>
            <div className="relative space-y-1">
              <input
                id="maximum_uses"
                type="number"
                name="maximum_uses"
                placeholder="Usage Limit"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                value={formData.maximum_uses}
                onChange={handleChange}
              />
              {maximumUsesError && <span className="text-sm text-red-500">{maximumUsesError}</span>}
            </div>
          </div>

          <div className="space-y-2">
            <label
             htmlFor="start_date"
             className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
             >
              Start Date
            </label>
            <div className="relative space-y-1">
              <input
                id="start_date"
                type="date"
                name="start_date"
                placeholder="Start Date"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                value={formData.start_date}
                onChange={handleChange}
              />
              {startDateError && <span className="text-sm text-red-500">{startDateError}</span>}
            </div>
          </div>
          <div className="space-y-2">
            <label
             htmlFor="expiration_date"
             className="text-sm font-medium leading-none peer-disabled:cursor-not-allowed peer-disabled:opacity-70"
             >
              Expiration Date
            </label>
            <div className="relative space-y-1">
              <input
                id="expiration_date"
                type="date"
                name="expiration_date"
                placeholder="Expiration Date"
                className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
                value={formData.expiration_date}
                onChange={handleChange}
              />
              {expirationDateError && <span className="text-sm text-red-500">{expirationDateError}</span>}
            </div>
          </div>
          <div className="space-y-2">
            <label
             htmlFor="description"
             >
              Description
            </label>
            <div className="relative space-y-1">
            <textarea
              id="description"
              name="description"
              placeholder="Description"
              className="peer w-full focus:outline-none focus:border-b focus:border-gray-400 peer h-10 px-0 bg-transparent border-0 border-b input-border-bottom rounded-none focus-visible:ring-0 focus-visible:border-gray-400 placeholder:text-gray-400"
              rows="4"
              value={formData.description}
              onChange={handleChange}
            ></textarea>
            {descriptionError && <span className="text-sm text-red-500">{descriptionError}</span>}
            </div>
          </div>


        </div>
          <div className="flex items-center justify-evenly">
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg my-2  mr-2"
            type="submit"
          >
            Submit
          </button>
          <button
            className="inline-flex items-center justify-center gap-2 whitespace-nowrap text-sm font-medium transition-colors focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:pointer-events-none disabled:opacity-50 [&amp;_svg]:pointer-events-none [&amp;_svg]:size-4 [&amp;_svg]:shrink-0 shadow px-4 py-2 w-full h-8 bg-[#6C38FF] hover:bg-[#5b2ee6] text-white rounded-lg mt-2 my-2"
            type="button"
            onClick={() => setShowModal(false)}
          >
            Close
          </button>
        </div>
      </form>

      </Modal>

    </>
  )
}

export default CouponModal